import { useEffect, useState } from 'react';
import { useFeature, useFeaturesCarregadas } from '../../context/FeaturesContext';
import { carregarPromocoesHome } from './promocoesHome';

/**
 * Quem ocupa o hero da Home: os banners ou as campanhas da Central.
 *
 * O flash que existia vinha da ordem de chegada: as flags começam com os
 * defaults (Central desligada), então o carrossel desenhava os banners e só
 * depois, com a flag e as campanhas carregadas, saía de cena. A decisão agora
 * espera os dados reais e, enquanto espera, a Home mostra o esqueleto do hero,
 * que tem a mesma altura dos dois heros. Não existe atraso artificial: o
 * esqueleto some no instante em que a última resposta necessária chega.
 *
 *   flags ainda não chegaram               -> 'carregando'
 *   Central desligada                      -> 'banners'
 *   Central ligada, promoções carregando   -> 'carregando'
 *   Central ligada, sem campanha (ou erro) -> 'banners'
 *   Central ligada, com campanha ativa     -> 'campanha'
 */
export function decidirHero({ featuresCarregadas, promotionsHub, promocoes }) {
    if (!featuresCarregadas) return 'carregando';
    if (!promotionsHub) return 'banners';
    if (promocoes === undefined) return 'carregando';
    const campanhas = promocoes && Array.isArray(promocoes.campaigns) ? promocoes.campaigns : [];
    return campanhas.length > 0 ? 'campanha' : 'banners';
}

/** `promocoes`: undefined enquanto não buscou, null se a busca falhou. */
export function useDecisaoHero() {
    const featuresCarregadas = useFeaturesCarregadas();
    const promotionsHub = useFeature('promotions_hub');
    const [promocoes, setPromocoes] = useState(undefined);

    useEffect(() => {
        if (!featuresCarregadas || !promotionsHub) return undefined;
        let ativo = true;
        carregarPromocoesHome().then((d) => { if (ativo) setPromocoes(d || null); });
        return () => { ativo = false; };
    }, [featuresCarregadas, promotionsHub]);

    return { estado: decidirHero({ featuresCarregadas, promotionsHub, promocoes }), promocoes };
}
